import { Link } from 'react-router-dom';
import useScrollReveal from '@/hooks/useScrollReveal';
import { services } from '@/mocks/services';

const ServicesOverview = () => {
  const headerRef = useScrollReveal();
  const gridRef = useScrollReveal();

  return (
    <section className="bg-cream py-24 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div ref={headerRef} className="reveal max-w-2xl mb-14">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-[2px] bg-gold" />
            <span className="font-inter text-gold text-xs font-semibold tracking-[0.25em] uppercase">
              Our Programs
            </span>
          </div>
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-charcoal leading-tight">
            Specialized Vocational &amp; Job Training Programs
          </h2>
          <p className="font-inter text-base text-charcoal/60 leading-relaxed mt-4 max-w-xl">
            Every program is designed around one goal: getting you employed, independent, and building a future you own.
          </p>
        </div>

        {/* Grid */}
        <div ref={gridRef} className="reveal grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => (
            <Link
              to="/services"
              key={service.id}
              className={`group relative bg-white rounded-lg p-7 border border-cream-100 hover:border-gold/40 transition-all duration-300 cursor-pointer delay-${Math.min(i * 100, 500)}`}
            >
              {/* Top accent line on hover */}
              <div className="absolute top-0 left-0 right-0 h-[3px] bg-gold rounded-t-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="w-12 h-12 flex items-center justify-center bg-gold/10 rounded-lg mb-5 group-hover:bg-gold/20 transition-colors duration-200">
                <i className={`${service.icon} text-gold text-xl`} />
              </div>
              <h3 className="font-playfair text-xl font-bold text-charcoal mb-3 leading-snug">
                {service.title}
              </h3>
              <p className="font-inter text-sm text-charcoal/60 leading-relaxed mb-5">
                {service.shortDesc}
              </p>
              <span className="inline-flex items-center gap-1.5 text-gold font-inter text-sm font-semibold group-hover:gap-2.5 transition-all duration-200">
                Learn More <i className="ri-arrow-right-line" />
              </span>
            </Link>
          ))}
        </div>

        {/* Mid-page CTA */}
        <div className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 border-2 border-charcoal hover:border-gold hover:text-gold text-charcoal font-inter font-semibold text-sm px-8 py-3.5 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Explore All Programs
            <i className="ri-arrow-right-line" />
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-gold hover:bg-gold-dark text-charcoal font-inter font-bold text-sm px-8 py-3.5 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Enroll Today
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
